import {
  ADSSO_TOKEN_EXPIRY,
  AUTH_TYPE,
  EMAIL_LOGIN_VERIFICATION_RESULT,
  LOGIN_COMPLETED,
  REDIRECT,
  REDIRECT_URI,
  RESTRICTED,
  USER_DATA_NAMESPACE,
  USER_SESSION_EXPIRED_TIME,
  USER_SESSION_ID,
} from "../constants/storage";
import { Cookie, LocalStorage } from "./storage";

/**
 * Clears every browser-side trace of a session.
 *
 * Shared by logout and the 401 handler so the two cannot drift. Notably
 * RESTRICTED must be cleared here: a stale "true" makes Http.shouldAbortApiCall
 * silently return empty data for /summary and /service on the next session.
 *
 * Removing USER_SESSION_ID is what signals other tabs to log out (IdleTimer
 * watches it), so it is removed for every auth type, not just SA/DL.
 */
export const clearAuthStorage = () => {
  LocalStorage.remove(USER_DATA_NAMESPACE);
  LocalStorage.remove(AUTH_TYPE);
  LocalStorage.remove(EMAIL_LOGIN_VERIFICATION_RESULT);
  LocalStorage.remove(USER_SESSION_ID);
  LocalStorage.remove(USER_SESSION_EXPIRED_TIME);

  sessionStorage.removeItem(RESTRICTED);
  sessionStorage.removeItem(REDIRECT);
  sessionStorage.removeItem(LOGIN_COMPLETED);
  Cookie.remove(REDIRECT_URI);
};
